import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      width={52}
      height={15}
      viewBox="0 0 52 15"
      {...props}
    >
      <path
        d="M17.774 15v-2.526h2.54V0h-5.079v12.474h-2.539V0H7.618v12.474h-2.54V0H0v12.474h2.54V15h15.234zm14.574 0V2.526h5.078V0H22.191v2.526h5.079V15h5.078zm12.034 0V8.368h5.079V5.842h-5.079V2.526H52V0H39.304v15h5.078z"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default SvgComponent